/**
 * Abacus journal import wire shape. Matches the BE handoff contract
 * (POST /api/integrations/abacus/import).
 *
 * The import RESULT shape is shared with D365 BC via
 * `IJournalImportResult` in `./journal-import.model`.
 *
 * Unlike D365 BC, Abacus has no fiscal-year discovery endpoint: the FE pulls
 * `fiscalYear*` and (conditionally) `previousFiscalYear*` from the active
 * Annual Report's General Info instead of asking the vendor.
 */
export interface IAbacusImportBody {
    companyId: string;
    connectionId: string;
    /** Abacus Mandant number (string), sourced from the connection mapping. */
    externalCompanyId: string;
    /** ISO YYYY-MM-DD — DocumentDateFrom on the AbaReport side. */
    fiscalYearStart: string;
    /** ISO YYYY-MM-DD — DocumentDateTo on the AbaReport side. */
    fiscalYearEnd: string;
    /** Optional YoY pair — both halves or neither, BE rejects partial. */
    previousFiscalYearStart?: string;
    previousFiscalYearEnd?: string;
}
